// The design's own tokens (`Gut Health v12.dc.html`), shared with the hormones
// feature where they match. The view models hand them to the UI as plain values.

export { RUST, RUST_TEXT, RAMP_FG } from '../../../hormones/core/model/palette';

/** Bowel calendar ramp (% normal stools) and its text colours. */
export const BRN = ['#F3ECE7', '#E2D3C8', '#C9AE9B', '#A3826C', '#6E5242'];
export const BRN_FG = ['#2a1a12', '#2a1a12', '#2a1a12', '#fff', '#fff'];
/** Fibre calendar ramp (% of target) and its text colours. */
export const GRN = ['#EEF4EE', '#D3E5D4', '#AFCFB1', '#7FAF83', '#4F8656'];
export const GRN_FG = ['#1f2a20', '#1f2a20', '#1f2a20', '#fff', '#fff'];

/** Bristol type chip colours: [background, text]. */
export const BRISTOL = {
  1: ['#5C3A24', '#fff'],
  2: ['#8B5A3C', '#fff'],
  3: ['#7FA66F', '#fff'],
  4: ['#4F8656', '#fff'],
  5: ['#E3B25A', '#3a2a10'],
  6: ['#D07A3A', '#fff'],
  7: ['#B4472B', '#fff'],
};
/** Stool category chips in the day detail: [background, text]. */
export const CATEGORY_CHIP = { Hard: ['#F1ECE8', '#5a4a3a'], Normal: ['#E3F0E7', '#2F7A4D'], Loose: ['#FBEFD9', '#7A4E0E'] };

/** Urgency / straining levels 0–3 and their colours. */
export const LEVELS = ['No', 'A little', 'Some', 'A lot'];
export const LEVEL_COLOURS = ['#5B8C93', '#EBC3B3', '#D99A82', '#8E4330'];
export const URGENCY_BAR = '#D99A82';
export const STRAIN_BAR = '#8E4330';
export const COMPLETE = '#4F8656';
export const INCOMPLETE = '#C8553D';

/** The first logged week's bar on every trend. */
export const REFERENCE_BAR = '#D9D2CC';
export const DASH = 'repeating-linear-gradient(90deg,#3a3a3a 0 5px,transparent 5px 8px)';

/** Daily Log tabs, in order. */
export const GUT_TABS = [
  { id: 'sym', name: 'Symptoms' },
  { id: 'bowel', name: 'Bowel Health' },
  { id: 'nut', name: 'Nutrition' },
];
